import React, { useEffect, useState,useRef } from 'react';
import axios from 'axios';
import AppStrings from '../../config/appstring';
//import { handleExport } from '../../utils/exportUtils';
import ExportSelect from '../../Class/ExportType';
import ClassSelect from '../../Class/ClassSelect';
import SectionSelect from '../../Class/Section';
import { handleExport } from '../Print/ExportToExcel'; 

const CollectionReport = ({user}) => {
  const [data, setData] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [feeDetails, setFeeDetails] = useState([]);
  const [admissionDate, setAdmissionDate] = useState(new Date().toISOString().split('T')[0]);
const [exportFormat, setExportFormat] = useState('');
const [formData, setFormData] = useState({ CLASS1: '' ,SECTION1:'',ADDFEES1:'',CLASS2: '' ,SECTION2:'',ADDFEES2:''});
const [feeDetailsMap, setFeeDetailsMap] = useState({});
 const tableRef = useRef(null);

  useEffect(() => {
   
 
console.log("Logged in as:", user?.name);
    //fetchStudentData();
  }, [user]);

  

  const fetchStudentData = async () => {
    try {
       // console.log("11111111111111kkkkkkkkkkkkkkjjjjjjjjjjjjjjjjj");
      const { FromDate, ToDate } = formData;
  
      // If any of these are required, add validation
      if (!FromDate  || !ToDate) {
        alert("Please select class, section and fee type.");
        return;
      }
  //console.log(CLASS1, SECTION1, ADDFEES1);
 // console.log(AppStrings.StudentPromotionList+`?TYPE=${ADDFEES1}&CLASS=${CLASS1}&SECTION=${SECTION1}`,'llllllllllllll');
      const response = await axios.get(AppStrings.CollectionReport+`?FROMDATE=${FromDate}&TODATE=${ToDate}`, {
        params: {
          ToDate,
          FromDate,
          FEESTYPE: FromDate,
        }
      });

     // console.log("kkkkkkkkkkkkkkjjjjjjjjjjjjjjjjj");
  
      const result = response.data.data.result || response.data.data;
  
      if (Array.isArray(result)) {
        setData(result);
        setError('');

      //  setFeeDetailsMap(result);
      //  console.log(feeDetailsMap,'details.....');

      } else {
        setError('Unexpected response format');
      }
    } catch (err) {
      setError('Failed to fetch data');
      console.error("Fetch error:", err.message || err);
    } finally {
      setLoading(false);
    }
  };


  const handleInputChange = (index, field, value) => {
    const updated = [...feeDetails];
    updated[index][field] = value;
    setFeeDetails(updated);
  };

  const handleCancel = () => {
    setSelectedRow(null);
    setFeeDetails([]);
  };

  const totalPaid = feeDetails.reduce((sum, fee) => sum + (parseFloat(fee.current) || 0), 0);


  //  const [firstName, setFirstName] = useState("");
  //       const [lastName, setLastName] = useState("");
        
  const handleSubmit = async () => {
    const studentsToSubmit = data.filter((student) =>
      selectedStudents.includes(student.STUDENT_ID)
    );
  
    const payload = studentsToSubmit.map((student) => ({
      student: {
        id: student.STUDENT_ID,
        admissionDate,
        class: formData.CLASS2, 
        section:formData.SECTION2,
        type:formData.ADDFEES2
      } // or remove this key entirely if not needed
    }));
  
    if (payload.length === 0 || formData.CLASS2==="") {
      alert("No valid student fee data to submit.");
      return;
    }
  
    try {
      const res = await fetch(AppStrings.StudentPromotionEntry, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
  
      const result = await res.json();
      alert(result.message || "Data saved successfully!");
      fetchStudentData();
    } catch (err) {
      console.error("Error:", err);
      alert("Failed to save data.");
    }
  };
  
  
    const handleChange = (e) => {
        const { name, value } = e.target;
  setFormData({ ...formData, [name]: value });
      };

  const handleExportClick = () => {
    console.log(tableRef.current)
     // handleExport(data, exportFormat, 'Collection Report');
      handleExport(tableRef.current, exportFormat, 'Collection Report');
    };

    
  const handleCheckboxChange = (studentId) => {
    setSelectedStudents((prev) =>
      prev.includes(studentId)
        ? prev.filter((id) => id !== studentId)
        : [...prev, studentId]
    );
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      const allIds = data
        .filter((row) =>
          row.NAME.toLowerCase().includes(search.toLowerCase()) ||
          row.STUDENT_ID.toLowerCase().includes(search.toLowerCase())
        )
        .map((row) => row.STUDENT_ID);
      setSelectedStudents(allIds);
    } else {
      setSelectedStudents([]);
    }
  };

  

  return (
    <div style={totalHight}>
      <div style={HeaderTitle} >Collection Report</div>

      {/* {loading && <p>Loading data...</p>} */}
      {error && <p style={{ color: 'red' }}>{error}</p>}


      <div className="row ReportHeader">
        <div className="col-25">
        <div className="row">
        <div className="col-251">
          
          <div className="coolinput">
          <label for="input" class="text">From Date:</label>
            <input
              required
              type="date"
              name="FromDate"
              autoComplete="off"
              className="input"
              value={formData.FromDate}
              onChange={handleChange} 
            />
         
          </div>
        </div>
        <div className="col-751">
         <div className="coolinput">
          <label for="input" class="text">To Date:</label>
            <input
              required
              type="date"
              name="ToDate"
              autoComplete="off"
              className="input"
              value={formData.ToDate}
              onChange={handleChange} 
            />
         
          </div>
        </div>
        <div className="col-751 colM ">
    <br/>
<button className='GridButton' onClick={fetchStudentData} >
  View
</button>

</div>
      </div>
      
        </div>
        <div className="col-75 ">
        <div className="row ">
        <div className="col-25 colM ReportExport">
        <ExportSelect
      value={exportFormat} // Controlled value for the select dropdown
      onChange={(e) => setExportFormat(e.target.value)} // Handle change to update formData
    />
    
    </div>
    <div className="col-75 colM ReportExport">
    <button className='GridButton' onClick={handleExportClick} disabled={!exportFormat}>
  Export
</button>
    
    </div>
    </div>
      </div>
      </div>

      {!loading && !error && Array.isArray(data) && (
        <div style={{ maxHeight: '500px', overflowY: 'auto', border: '1px solid #ccc' }}>
          <table ref={tableRef} style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                 <th style={{ ...headerCellStyle, width: '50px' }}>S.No</th>
                  <th style={{ ...headerCellStyle, width: '80px' }}>Vou.No</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Student ID</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Name</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Class</th>
               <th style={{ ...headerCellStyle, width: '100px' }}>Type</th>
               <th style={{ ...headerCellStyle, width: '100px' }}>Collection</th>
               <th style={{ ...headerCellStyle, width: '100px' }}>Vou.Date</th>
               <th style={{ ...headerCellStyle, width: '100px' }}>Trans.ID</th>
                {/* <th style={{ ...headerCellStyle, width: '120px' }}>Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {data
                .filter((row) =>
                  row.NAME.toLowerCase().includes(search.toLowerCase()) ||
                  row.STUDENT_ID.toLowerCase().includes(search.toLowerCase())
                )
                .map((row, index) => (
                  <tr  key={index}
        style={{
          backgroundColor:
            row.NAME?.toLowerCase() === 'grand total' ? '#ffcccc' : 'transparent',
        }}>
                     <td style={cellStyle}>{row.SNO}</td>
                    <td style={cellStyle}>{row.VOUNO}</td>
                    <td style={cellStyle}>{row.STUDENT_ID}</td>
                    <td style={cellStyle}>{row.NAME}</td>
                    <td style={cellStyle}>{row.CLASS}</td>
                  <td style={rightAlignCell}>  {row.PAYMODE && row.PAYMODE.trim() !== '' ? row.PAYMODE : 'CASH'}</td>
                  <td style={rightAlignCell}>{row.TOTAL.toFixed(2)}</td>
                  <td style={cellStyle}>{row.VOU_DATE}</td>
                  <td style={cellStyle}>{row.REFNO}</td>
                  
                    {/* <td style={cellStyle}>
                      <button className="GridButton" onClick={() => handlePayClick(row)}>Pay</button>
                      <button className="GridButton" onClick={handleCancel}>Cancel</button>
                    </td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

// Styles

const HeaderTitle={
 fontSize: '20px',
  fontWeight: 'bold',
}

const totalHight={

}


const headerCellStyle = {
  border: '1px solid #ddd',
  padding: '8px',
  backgroundColor: '#f2f2f2',
  position: 'sticky',
  top: 0,
  zIndex: 1,
};

const cellStyle = {
  border: '1px solid #ddd',
padding: '5px',
  fontSize:'13px'
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '700px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
  textAlign: 'center',
};

const rightAlignCell = {
  ...cellStyle,
  textAlign: 'right'
};

const rightAlignHeader = {
  ...headerCellStyle,
  textAlign: 'right'
};

export default CollectionReport;
